import { Button } from "@gigpro/ui/Button";
import { Dialog, DialogTitle } from "@gigpro/ui/Dialog";
import { Switch } from "@gigpro/ui/Switch";
import { Copy, Wrench } from "lucide-react";
import { type PowerUserFeatures, usePowerUserFeatures } from "services/powerUser";
import { copyToClipboard } from "utils/copyToClipboard";

type PowerUserMenuProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

type FeatureDefinition = {
  key: keyof PowerUserFeatures;
  label: string;
  description: string;
};

const features: Array<FeatureDefinition> = [
  {
    key: "inlineRoster",
    label: "Inline Time and Attendance Editing",
    description: "Edit clock in/out directly on the Pro Card",
  },
];

export function PowerUserMenu({ open, onOpenChange }: Readonly<PowerUserMenuProps>) {
  const { features: currentFeatures, setFeatures } = usePowerUserFeatures();

  return (
    <Dialog open={open} onOpenChange={onOpenChange} bottomSheet closeOnBackdropClick>
      <DialogTitle>
        <Wrench className="mr-1.5 inline size-3.5" />
        Power Tools
      </DialogTitle>
      <div className="flex flex-col gap-2">
        {features.map(({ key, label, description }) => (
          <label key={key} htmlFor={`power-user-${key}`} className="flex items-center justify-between gap-3">
            <p className="flex flex-col gap-0.5 font-semibold">
              <span className="flex items-center gap-0.5">
                {label}
                <Button
                  size="small"
                  className="py-0 text-gray"
                  onClick={() => void copyToClipboard(key, "Copied to clipboard")}
                >
                  <code>{key}</code>
                  <Copy className="size-2.5" />
                </Button>
              </span>
              <span className="text-small font-regular text-gray">{description}</span>
            </p>
            <Switch
              id={`power-user-${key}`}
              checked={currentFeatures[key]}
              onCheckedChange={(checked) => setFeatures((prev) => ({ ...prev, [key]: checked }))}
            />
          </label>
        ))}
      </div>
    </Dialog>
  );
}
